import React from 'react';
import { Box, Card } from '@mui/material';

import PostCard from '../../DesignSystem/PostCard/PostCard';
import PostListItem from '../../DesignSystem/PostListItem/PostListItem';
import { PostCategories, PostTypes } from '../../../Utils/Types';
import { Post } from '../../../Utils/Types/Posts';
import { Space } from '../../../Utils/Types/Space';

const renderPost = (post: Post, space: Space) => {
  const trackingProps = { category: 'Space', name: 'Search - Card Click' };

  if (post.type === PostTypes.IDEA) {
    return (
      <Card>
        <PostListItem
          trackingProps={trackingProps}
          post={post}
          space={space}
          parent={post.included.source}
          currentStep={post.included.source.current_step}
          parentLink
          hideButtons
        />
      </Card>
    );
  }

  if (
    PostCategories.COMMUNICATION.includes(post.type) ||
    PostCategories.CONSULTATION.includes(post.type) ||
    PostCategories.FOLDER.includes(post.type)
  ) {
    return (
      <PostCard
        trackingProps={trackingProps}
        post={post}
        parent={post.included.source}
        entity={space}
      />
    );
  }

  return null;
};

const InfinitePosts = ({ posts, space }: any) => {
  return posts.map((post: any) => (
    <Box key={post.id} role="listitem" sx={{ my: 2 }}>
      {renderPost(post, space)}
    </Box>
  ));
};

export default InfinitePosts;
